import { createStyles, PinInput, type PinInputProps } from '@mantine/core';

type PinInputRegister = {
  value: string;
  onChange: (value: string) => void;
  onBlur?: () => void;
  onFocus?: () => void;
  onComplete?: () => void;
  error?: string | undefined;
};

type InputFieldProps = PinInputProps & {
  className?: string;
  register: PinInputRegister;
};

const useStyles = createStyles((theme) => ({
  root: {
    position: 'relative',
  },

  required: {
    transition: 'opacity 150ms ease',
  },

  input: {
    border: 'none',
    backgroundColor: '#f7f7f7',
    outline: 'none',
    height: 50,
    width: 50,
    fontSize: '16px',
    fontWeight: 600,
    borderRadius: '8px',
    color: 'black !important',
  },
  rightSection: {
    right: theme.spacing.xs,
    // if the input has value, show the clear icon or else hide it
  },
}));

export const PinInputField = (props: InputFieldProps) => {
  const { type, register } = props;

  const { classes } = useStyles();
  const { value, error, onChange } = register;

  return (
    <PinInput
      {...props}
      type={type}
      classNames={classes}
      error={!!error}
      value={value}
      onChange={onChange}
      onKeyUp={(e: any) => {
        if (e.key === 'Enter') {
          e.target.blur();
        }
      }}
      oneTimeCode
      placeholder=""
    />
  );
};
